import { getTranslations } from 'next-intl/server';
import { use } from 'react';
import { LoadingOrErrorContent } from './LoadingOrErrorContent';

export const LoadingOrError = ({ error }: { error?: string }) => {
  const t = use(getTranslations('creation.page_errors'));

  return (
    <LoadingOrErrorContent
      error={error}
      clickToReloadPageButtonText={t('click_to_reload_button')}
      reloadPageButtonAriaLabel={t('reload_page_a11y')}
    />
  );
};
